import React from 'react';
import './configable-table.scss'

type Props = {
  columns: { [key: string]: string | Function },
  visibleColumns: string[],
  rows: any[]
};

export default ({ columns, visibleColumns, rows }: Props) => {
  return <table className="configable-table">
    <thead>
      <tr key="header">
        {visibleColumns.map(col => (<td key={col}>{col}</td>))}
      </tr>
    </thead>
    <tbody>
      {rows.map(row => {
        return <tr key={row[columns.key as string]}>
          {visibleColumns.map(col => {
            const Key = columns[col]; // can either be a prop of the row/model Or a component
            const td_content = Key instanceof Function ? <Key data={row} /> : row[Key as string];
            const td_key = `${col}:` + ((null == td_content) ? 'null' : td_content);
            return <td key={td_key}>
              {td_content}
            </td>;
          })}
        </tr>;
      })}
    </tbody>
  </table>;
}
